import { useEffect, useState } from 'react'
import ParticlePortrait from '../ParticlePortrait'
import FadeInSection from '../FadeInSection'
import './index.scss'

const Home = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 150)
    return () => clearTimeout(t)
  }, [])

  return (
    <section id="home" className="home-section">
      <div className={`home-content${visible ? ' visible' : ''}`}>

        <div className="home-portrait">
          <ParticlePortrait />
        </div>

        <div className="home-text">
          <p className="greeting">Hi, I'm</p>
          <h1 className="home-name">Akshata Dhuraji.</h1>
          <h2 className="home-subtitle">Software Engineer</h2>
          <p className="home-desc">
            I'm a Software Engineer at Hub Systems, passionate about building AI systems,
            web dev, app development, and system design. I love seeing more female
            representation in tech — check out my projects or reach out!
          </p>
          <FadeInSection delay="0.35s">
            <div className="home-actions">
              <a href="#contact" className="cta-btn">Get in touch</a>
              <a
                href="https://drive.google.com/file/d/1GkGn41suhNMdswFD9Upb9MPDjBU3PKOS/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="resume-link"
              >
                View Resume ↗
              </a>
            </div>
          </FadeInSection>
        </div>

      </div>
    </section>
  )
}

export default Home
